// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Bank } from './bank';
import { Lookup } from './lookup';
import { Reconciliation } from './reconciliation';
import { Transfer } from './transfer';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Batch extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  batchId!: number;
  accountId!: number;
  approvalFlags?: number;
  authorisedByUserId?: number;
  authorisedDate?: Date;
  bankId?: number;
  batchCount!: number;
  batchDate!: Date;
  batchTotal!: number;
  batchTypeLookupId?: number;
  createdBy!: string;
  createdDate!: Date;
  data?: string;
  docData?: string;
  groupId?: number;
  isGroupDeposit!: boolean;
  memo?: string;
  nextFlags?: number;
  payrollFlags?: number;
  postedByUserId?: number;
  preparedByUserId?: number;
  reconciliationId?: number;
  rejectionFlags?: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webFlags?: number;
  account!: Account;
  authorisedByUser!: User;
  bank!: Bank;
  batchTypeLookup!: Lookup;
  postedByUser!: User;
  preparedByUser!: User;
  reconciliation!: Reconciliation;
  transfers!: Transfer[];
}

